import { createAsyncThunk } from "@reduxjs/toolkit";
// import { AppTimerStateType } from "@parent-app/types";
import { AppTimerActions } from "./AppTimerSlice";
import { AppTimerStateType } from "src/shared/types/src";

export const updateAppTimer = createAsyncThunk(
    "updateAppTimer", async ({ lastBackgroundInitTime }: { lastBackgroundInitTime: number }, { dispatch }) => {
        dispatch(AppTimerActions.setAppTimer({ lastBackgroundInitTime }));
    }
);

export const updateEyengageLastUpdateTime = createAsyncThunk(
    "updateEyengageLastUpdateTime", async ({ eyengageLastUpdateTime }: { eyengageLastUpdateTime: number }, { dispatch }) => {
        dispatch(AppTimerActions.setEyengageLastUpdateTime({ eyengageLastUpdateTime }));
    }
);